import React, { useMemo } from 'react';
import { Text } from '@amzn/stencil-react-components/text';
import { useTranslation } from 'react-i18next';
import { Flex, Spacer } from '@amzn/stencil-react-components/layout';
import { useUserDataContext } from '../hooks';
import { QualityEvent } from '../types/backendService';
import { Spinner } from '@amzn/stencil-react-components/spinner';
import { QualityEventCards } from './shared/QualityEventCards';

export const CurrentWeekQualityTab = ({}) => {
  const { t } = useTranslation();
  const { currentWeekQualityEvents } = useUserDataContext();

  const isLoading = currentWeekQualityEvents == undefined;
  const qualityEvents: QualityEvent[] = currentWeekQualityEvents || [];

  const qualityEventsCards = useMemo(() => {
    return (
      <QualityEventCards qualityEvents={qualityEvents} />
    );
  }, [qualityEvents]);

  let qualityEventsContent;
  if (isLoading) {
    qualityEventsContent = (
      <Flex flexDirection="row" justifyContent="center" alignItems="center">
        <Spinner showText loadingText={t('loadingQualityEvents')} />
      </Flex>
    );
  } else if (qualityEvents.length > 0) {
    qualityEventsContent = (
      <>
        <Text fontWeight="light">{t('qualityEventsIntro')}</Text>
        <Spacer height={16}/>
        {qualityEventsCards}
      </>
    );
  } else {
    return (
      <Text>{t('noQualityEvents')}</Text>
    );
  }

  return qualityEventsContent;
}
